import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { setActiveItem, toggleEditPanel, updateEditableLink } from '../../../containers/Editor/actions';
import EditPanel from '../../../containers/Editor/EditPanel';
import LinkPanel from '../../../containers/Editor/EditPanel/LinkPanel';
import ThemesPanel from '../../../containers/Editor/EditPanel/ThemesPanel';
import { EditableType, IGNORE_PAGE_CLICK_CLASSNAME } from '../../../containers/Editor/constants';
import { getBorderWidth, LinkData } from '../../../containers/Editor/utils/helpers';
import { Wrapper, Border, IconLink } from './styles';
import Utils from '../../../utils';

interface LinkEditorProps {
	page: number;
	id: string;
	pageScale: number;
	spreadZoom: number;
	isActive: boolean;
	linkData: LinkData;
	isEditPanelDisplayed: boolean;
	hasEditableImage: boolean;
	isThemedItem: boolean;
	dispatch: Dispatch<StoreState>;
}

const LinkEditor = ({
	page,
	id,
	pageScale,
	spreadZoom,
	isActive,
	linkData,
	isEditPanelDisplayed,
	hasEditableImage,
	isThemedItem,
	dispatch,
}: LinkEditorProps) => {
	if (hasEditableImage) {
		return null;
	}

	const handleClick = () => {
		if (!isActive) {
			dispatch(setActiveItem(id, page, null));

			if (!isEditPanelDisplayed) {
				dispatch(toggleEditPanel());
			}
		}
	};

	const handleChange = (linkData: LinkData) => {
		dispatch(updateEditableLink(page, id, {linkData}));
	};

	const renderEditPanel = () => {
		const panels = {
			[EditableType.link]: (
				<LinkPanel
					linkData={linkData}
					onChange={handleChange}
				/>
			),
		};

		if (isThemedItem) {
			panels[EditableType.themes] = <ThemesPanel />;
		}

		return (
			isActive && isEditPanelDisplayed && (
				<EditPanel
					defaultType={EditableType.link}
					panels={panels}
				/>
			)
		);
	};

	const editorClasses = Utils.getCssClasses(`${IGNORE_PAGE_CLICK_CLASSNAME} uprez-link-editor`, {
		'is-active': isActive,
		'has-image': hasEditableImage,
	});

	return (
		<>
			<Wrapper
				className={editorClasses}
				isActive={isActive}
				onClick={handleClick}
				onTouchEnd={handleClick}
			>
				{isActive &&
					<Border
						isActive={isActive}
						borderWidth={getBorderWidth(pageScale)}
					/>
				}
				<IconLink
					className="uprez-link-editor-icon"
					pageScale={pageScale}
					spreadZoom={spreadZoom}
				>
					{Utils.getSvgIcon('iconset_uprez_link2')}
				</IconLink>
			</Wrapper>
			{renderEditPanel()}
		</>
	);
};

export default LinkEditor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/LinkEditor/index.tsx